<template>
    <div class="invoicing-page">
        <form class="form" method="post" :action="action" autocomplete="off" @submit="saveState">
            <slot></slot>

            <p>{{ ordersChecked.length }} commandes sélectionnées</p>
            <table class="table table-striped table-bordered table-responsive">
                <thead>
                    <th>
                        Client
                        <div class="small">
                            <abbr title="Sélectionner les commandes">Select.</abbr>
                            <a href="javascript:void(0)"
                               @click="checkAll(true)">
                                Toutes
                            </a>
                            /
                            <a href="javascript:void(0)"
                               @click="checkAll(false)">
                                Aucune
                            </a>
                        </div>
                    </th>
                    <th v-for="date in dates">
                        {{ date }}
                        <div class="small">
                            <abbr title="Sélectionner les commandes">Select.</abbr>
                            <a href="javascript:void(0)"
                               @click="checkByDate(date, true)">
                                Toutes
                            </a>
                            /
                            <a href="javascript:void(0)"
                               @click="checkByDate(date, false)">
                                Aucune
                            </a>
                        </div>
                    </th>
                </thead>
                <tbody>
                    <tr v-for="customerWithOrdersByDate in customersWithOrdersByDate" :key="customerWithOrdersByDate.customer.id">
                        <td>
                            {{ customerWithOrdersByDate.customer.name }}
                            <div class="small">
                                <abbr title="Sélectionner les commandes">Select.</abbr>
                                <a href="javascript:void(0)"
                                   @click="checkByCustomerId(customerWithOrdersByDate.customer.id, true)">
                                    Toutes
                                </a>
                                /
                                <a href="javascript:void(0)"
                                   @click="checkByCustomerId(customerWithOrdersByDate.customer.id, false)">
                                    Aucune
                                </a>
                            </div>
                        </td>
                        <td v-for="date in dates" :key="date">
                            <div v-for="order in (customerWithOrdersByDate.orders[date] || [])" :key="order.reference">
                                <div>
                                    <a :href="'/espace-employes/commandes/preparation/commande/' + order.id">
                                        {{ order.reference }}
                                    </a>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input"
                                       v-if="order.status === 'DONE'"
                                       type="checkbox"
                                       name="orders[]"
                                       :id="'orderInvoicing' + order.id"
                                       :value="order.id"
                                       v-model="ordersChecked"
                                    />
                                    <i v-else
                                       class="form-check-input fad fa-exclamation-triangle text-danger"
                                       :title="erpEnabled ? 'Le statut de la commande ne permet pas la transmission à l\'ERP' : 'Le statut de la commande ne permet pas le calcul.'"></i>
                                    <label class="form-check-label" :for="'orderInvoicing' + order.id">
                                        {{ order.status_label }}
                                    </label>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <th>
                        Client
                        <div class="small">
                            <abbr title="Sélectionner les commandes">Select.</abbr>
                            <a href="javascript:void(0)"
                               @click="checkAll(true)">
                                Toutes
                            </a>
                            /
                            <a href="javascript:void(0)"
                               @click="checkAll(false)">
                                Aucune
                            </a>
                        </div>
                    </th>
                    <th v-for="date in dates" :key="date">
                        {{ date }}
                        <div class="small">
                            <abbr title="Sélectionner les commandes">Select.</abbr>
                            <a href="javascript:void(0)"
                               @click="checkByDate(date, true)">
                                Toutes
                            </a>
                            /
                            <a href="javascript:void(0)"
                               @click="checkByDate(date, false)">
                                Aucune
                            </a>
                        </div>
                    </th>
                </tfoot>
            </table>

            <div class="form-group col-6 mt-4 mb-4">
                <label for="ref_customer">
                    Référence client
                    <a href="javascript:void(0)"
                       class="btn btn-sm btn-outline-info"
                       @click="computeFields" >
                        Calculer automatiquement
                    </a>
                </label>
                <input type="text" class="form-control" name="ref_customer" id="ref_customer" v-model="refCustomer" required>
            </div>

            <div class="form-group col-6 mt-4 mb-4">
                <label for="invoice_date">
                    Date de facturation
                </label>
                <BootstrapDatepicker
                    name="invoice_date"
                    id="invoice_date"
                    v-model="invoiceDate"
                    format="yyyy-MM-dd"
                    required
                />
            </div>

            <button class="btn btn-success float-right" :disabled="!ordersChecked.length">
                <template v-if="erpEnabled">
                    <i class="fad fa-exchange"></i> Transmettre les {{ ordersChecked.length }} commandes sélectionnées à l'ERP
                </template>
                <template v-else>
                    <i class="fad fa-exchange"></i> Voir les factures pour les {{ ordersChecked.length }} commandes sélectionnées
                </template>
            </button>
        </form>
    </div>
</template>

<script>
import BootstrapDatepicker from "./BootstrapDatepicker"

import {momentDay} from "../moment-with-helpers";

export default {
    name: "InvoicingPage",

    components: {
        BootstrapDatepicker
    },

    props: {
        action: {
            type: String,
            required: true,
        },
        customersWithOrdersByDate: {
            type: Object,
            required: true,
        },
        dates: {
            type: Object,
            required: true,
        },
        erpEnabled: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    data() {
        return {
            ordersChecked: [],
            refCustomer: '',
            invoiceDate: null,
        }
    },

    mounted() {
        this.restoreState();
        if (this.ordersChecked.length === 0) {
            this.checkAll(true);
        }
    },

    methods: {
        forEachOrder(fnc) {
            for (const custIndex in this.customersWithOrdersByDate) {
                const customerWithOrdersByDate = this.customersWithOrdersByDate[custIndex];
                for (const date in customerWithOrdersByDate.orders) {
                    for (const order of customerWithOrdersByDate.orders[date]) {
                        fnc(customerWithOrdersByDate.customer, date, order);
                    }
                }
            }
        },

        computeFields() {
            let higherDate = null;
            this.forEachOrder((customer, date, order) => {
                if (this.ordersChecked.includes(order.id)) {
                    if (!higherDate || momentDay(order.delivery_date) > higherDate) {
                        higherDate = momentDay(order.delivery_date);
                    }
                }
            });

            if (higherDate) {
                this.refCustomer = higherDate.format('MMMM YYYY');
                this.invoiceDate = higherDate.endOf('month').toDate();
            } else {
                this.refCustomer = 'inconnu';
                this.invoiceDate = null;
            }
        },

        selectOrder(orderToSelectId) {
            this.forEachOrder((customer, date, order) => {
                if (orderToSelectId === order.id) {
                    if (order.status !== 'DONE') {
                        this.unselectOrder(orderToSelectId); // Security to avoid selecting not 'DONE' orders
                        return;
                    }
                    if (!this.ordersChecked.includes(orderToSelectId)) {
                        this.ordersChecked.push(orderToSelectId);
                    }
                    return;
                }
            });
        },

        unselectOrder(orderId) {
            if (this.ordersChecked.includes(orderId)) {
                this.ordersChecked.splice(this.ordersChecked.indexOf(orderId), 1);
            }
        },

        checkByDate(orderDate, check = true) {
            const selectOrUnselectFunc = check ? this.selectOrder : this.unselectOrder;

            this.forEachOrder((customer, date, order) => {
                if (date === orderDate) {
                    selectOrUnselectFunc(order.id);
                }
            });
        },

        checkByCustomerId(customerId, check = true) {
            const selectOrUnselectFunc = check ? this.selectOrder : this.unselectOrder;

            const customerWithOrdersByDate = _.find(this.customersWithOrdersByDate, ['customer.id', customerId]);
            if (customerWithOrdersByDate) {
                for (const date in customerWithOrdersByDate.orders) {
                    for (const order of customerWithOrdersByDate.orders[date]) {
                        selectOrUnselectFunc(order.id);
                    }
                }
            }
        },

        checkAll(check = true) {
            const selectOrUnselectFunc = check ? this.selectOrder : this.unselectOrder;

            this.forEachOrder((customer, date, order) => {
                selectOrUnselectFunc(order.id);
            });
        },

        saveState() {
            localStorage.setItem('InvoicingPageSavedState', JSON.stringify({
                ordersChecked: this.ordersChecked,
                refCustomer: this.refCustomer,
                invoiceDate: this.invoiceDate,
            }));
        },

        restoreState() {
            const savedStateJSON = localStorage.getItem('InvoicingPageSavedState');
            localStorage.removeItem('InvoicingPageSavedState');
            if (savedStateJSON) {
                const savedState = JSON.parse(savedStateJSON);
                this.refCustomer = savedState.refCustomer || this.defaultRefCustomer;
                this.invoiceDate = savedState.invoiceDate;
                for (const orderChecked of savedState.ordersChecked) {
                    this.selectOrder(orderChecked);
                }
            }
        },
    },
}
</script>
